import { useState, useEffect } from 'react';
import * as tempStorage from 'unified-navigation-ui/utils/tempStorage';
import getWindow from '../../../utils/getWindow';
import getIsCmsOnboardingRoute from '../../../utils/getIsCmsOnboardingRoute';
import { isSeleniumRunning } from '../../../utils/testEnv';
export const useHelpTooltip = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  useEffect(() => {
    const {
      pathname,
      search
    } = getWindow().location;
    const isHelpInTheNavTooltipViewed = tempStorage.get('hubspot:helpInTheNav:userHasDismissedHelpTooltip') || isSeleniumRunning();
    const isOnboardingApp = pathname.includes('-demo') || pathname.includes('-tour');
    const isOnboardingTour = search.includes('tourId');
    const isCmsOnboardingRoute = getIsCmsOnboardingRoute();
    setShowTooltip(!isHelpInTheNavTooltipViewed && !isOnboardingApp && !isCmsOnboardingRoute && !isOnboardingTour);
  }, []);
  const closeHelpTooltip = () => {
    tempStorage.set('hubspot:helpInTheNav:userHasDismissedHelpTooltip', 'true');
    setShowTooltip(false);
  };
  return {
    showTooltip,
    closeHelpTooltip
  };
};